import {
    type IAddContractDto,
    type IUpdateContractDto,
    type IAddCompanyDto,
    type IUpdateCompanyDto,
    type IAddProgramDto,
    type IUpdateProgramDto,
    type ICreateInsuredDto,
    type IUpdateInsuredDto,
    type IPostProgramAttachRangeDto,
    type IPostSpecialConditionDto,
    type IPostSpecialConditionAttachRangeDto,
    type ITransferPoliciesDto
} from '@/app/types/dmsTypes'
import { API_URL } from '@Config/config'

import instance from '../instance'

export class DmsController {
    onGetImportHistory() {
        return instance.get(`${API_URL}/dms/import/history?limit=5`)
    }

    onGetImportTemplate(queries: string) {
        return instance.get(`${API_URL}/dms/import/template${queries}`)
    }

    onGetImportInfoById(queries: string) {
        return instance.get(`${API_URL}/dms/import/import-info-by-id${queries}`)
    }

    onAddImportTemplate(queries: string, dto: FormData) {
        return instance.post(`${API_URL}/dms/import${queries}`, dto)
    }

    onGetGuideMarkers() {
        return instance.get(`${API_URL}/policy-insureds/guide-markers`)
    }

    // insureds
    onGetInsuredsList(queries: string) {
        return instance.get(`${API_URL}/policy-insureds/in-company${queries}`)
    }

    onGetChosenInsured(queries: string) {
        return instance.get(`${API_URL}/policy-insureds/policy-by-id${queries}`)
    }

    onAddInsured(dto: ICreateInsuredDto) {
        return instance.post(`${API_URL}/policy-insureds`, dto)
    }

    onSaveInsuredChanges(dto: IUpdateInsuredDto) {
        return instance.put(`${API_URL}/policy-insureds`, dto)
    }

    onRemoveInsured(queries: string) {
        return instance.delete(`${API_URL}/policy-insureds${queries}`)
    }

    // companies
    onGetCompaniesList() {
        return instance.get(`${API_URL}/dms/insurance-company`)
    }

    onAddCompany(dto: IAddCompanyDto) {
        return instance.post(`${API_URL}/dms/insurance-company`, dto)
    }

    onSaveCompanyChanges(dto: IUpdateCompanyDto) {
        return instance.put(`${API_URL}/dms/insurance-company`, dto)
    }

    onRemoveCompany(queries: string) {
        return instance.delete(`${API_URL}/dms/insurance-company${queries}`)
    }

    onGetPolicyHoldersByCompanyId(queries: string) {
        return instance.get(`${API_URL}/dms/policy-holders/by-company-id${queries}`)
    }

    // contracts
    onGetCompanyContracts(queries: string) {
        return instance.get(`${API_URL}/dms/contracts${queries}`)
    }

    onAddContract(dto: IAddContractDto) {
        return instance.post(`${API_URL}/dms/contracts`, dto)
    }

    onUpdateContract(dto: IUpdateContractDto) {
        return instance.put(`${API_URL}/dms/contracts`, dto)
    }

    onRemoveContract(queries: string) {
        return instance.delete(`${API_URL}/dms/contracts${queries}`)
    }

    onTransferPolicies(dto: ITransferPoliciesDto) {
        return instance.post(`${API_URL}/dms/contracts/transfer-policies`, dto)
    }

    // programs
    onGetCompanyPrograms(queries: string) {
        return instance.get(`${API_URL}/dms/insurance-program${queries}`)
    }

    onAddProgram(dto: IAddProgramDto) {
        return instance.post(`${API_URL}/dms/insurance-program`, dto)
    }

    onUpdateProgram(dto: IUpdateProgramDto) {
        return instance.put(`${API_URL}/dms/insurance-program`, dto)
    }

    onRemoveProgram(queries: string) {
        return instance.delete(`${API_URL}/dms/insurance-program${queries}`)
    }

    onRemoveProgramAttachRange(queries: string) {
        return instance.delete(`${API_URL}/dms/insured-programs${queries}`)
    }

    onPostProgramAttachRange(dto: IPostProgramAttachRangeDto) {
        return instance.post(`${API_URL}/dms/insured-programs`, dto)
    }

    onPostSpecialCondition(dto: IPostSpecialConditionDto) {
        return instance.post(`${API_URL}/dms/special-condition`, dto)
    }

    onPostSpecialConditionAttachRange(dto: IPostSpecialConditionAttachRangeDto) {
        return instance.post(`${API_URL}/dms/special-condition/date-range`, dto)
    }

    onRemoveSpecialConditionAttachRange(queries: string) {
        return instance.delete(`${API_URL}/dms/special-condition/date-range${queries}`)
    }

    onGetLastErrors() {
        return instance.get(`${API_URL}/dms/import/last-errors`)
    }
}

// types
// type TCompanyDto = Omit<ICompany, 'id'>
// type TCompanyContractDto = Omit<IConpanyContract, 'id' | 'updateAt'>
// type TCompanyProgramDto = Omit<ICompanyProgram, 'id' | 'updateAt'>
